import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Planzone, CalendarHolidays, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignDefaultCalendarHolidaysToPlanzone(
    request: Boundaries["assignDefaultCalendarHolidaysToPlanzone"]["request"],
  ): void;
}

function useAssignCalendarHolidaysToPlanzone(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAssignCalendarHolidaysToPlanzoneRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAssignCalendarHolidaysToPlanzoneRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAssignCalendarHolidaysToPlanzoneRequestFailure(planzone),
    ),
    assignDefaultCalendarHolidaysToPlanzone:
      core.assignDefaultCalendarHolidaysToPlanzone,
  };
}

export { useAssignCalendarHolidaysToPlanzone };
